/**
 * overlay.ts —— 「当前是否有浮层挂起」的全局计数（第 4 轮整改 · QA-BUG-001）
 *
 * 为什么需要它：行动快捷键（F/C/K/R/A/←→）与页面级快捷键（H/S）分别注册在
 * ActionBar 与 GameScreen 的 window keydown 上，两者都不知道「此刻有没有浮层打开」。
 * QA 实测：二次确认气泡打开时按 F 会直接弃牌（气泡还留在屏幕上），
 * 误操作防护在键盘路径上完全可绕过。
 *
 * 用计数而不是布尔：浮层可以叠加（确认气泡 + 抽屉），任一未关闭都应继续拦截。
 * 注册点只有 `useDismissable`（所有浮层的公共入口），因此不会漏登记也不会重复登记。
 */

let openCount = 0;

/** 浮层挂载时登记，返回注销函数（在 effect cleanup 里调用）。 */
export function acquireOverlay(): () => void {
  openCount += 1;
  let released = false;
  return () => {
    if (released) return;
    released = true;
    openCount = Math.max(0, openCount - 1);
  };
}

/** 是否有浮层处于打开状态（全局快捷键应当让位）。 */
export function overlayOpen(): boolean {
  return openCount > 0;
}

/** 仅供单测复位。 */
export function __resetOverlays(): void {
  openCount = 0;
}
